/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TGetFederalSubjectsOfRussiaModel, IMappers, TGetFederalSubjectsOfRussiaResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetFederalSubjectsOfRussiaResponse } from '../../entities/response/GetFederalSubjectsOfRussiaResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetFederalSubjectsOfRussiaModel(): TGetFederalSubjectsOfRussiaModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'geo-temp-layer',
    pathApi: '/v1/get-federal-subjects-of-russia/',
    response: {
      '200': {
        contentType: 'json',
      },
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IGetFederalSubjectsOfRussiaOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchGetFederalSubjectsOfRussia<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IGetFederalSubjectsOfRussiaOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetFederalSubjectsOfRussiaResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetFederalSubjectsOfRussiaModel(),
    config,
  )) as FetchResponse<TGetFederalSubjectsOfRussiaResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetFederalSubjectsOfRussiaResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetFederalSubjectsOfRussiaResponse>;
}
